import { Point } from 'leaflet';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode, useState } from 'react';
import { SegmentationContextMenu } from '../components/SegmentationContextMenu';

interface IProps {
  children(openContextMenu: (position: Point, segmentationId: string) => void, contextMenuSegmentationId: string | undefined): ReactNode;
}

export const SegmentationContextMenuContainer = observer((props: IProps): ReactElement => {
  const [contextMenuPosition, setContextMenuPosition] = useState<Point | undefined>(undefined);
  const [contextMenuSegmentationId, setContextMenuSegmentationId] = useState<string | undefined>(undefined);

  const handleMenuOpen = (position: Point, segmentationId: string): void => {
    setContextMenuPosition(position);
    setContextMenuSegmentationId(segmentationId);
  };

  const handleMenuClose = (): void => {
    setContextMenuPosition(undefined);
    setContextMenuSegmentationId(undefined);
  };

  return (
    <>
      <SegmentationContextMenu
        position={contextMenuPosition}
        segmentationId={contextMenuSegmentationId}
        onMenuClose={handleMenuClose}
      />
      {props.children(handleMenuOpen, contextMenuSegmentationId)}
    </>
  );
});
